export default __webpack_public_path__ + "static/media/tabuleiro-desfocado.cd9ad9a9.webp";